const graphProps = {
  aluminum: { name: 'aluminum', color: '#696969' },
  boron: { name: 'boron', color: '#8b4513' },
  calcium: { name: 'calcium', color: '#808000' },
  copper: { name: 'copper', color: '#008000' },
  iron: { name: 'iron', color: '#008b8b' },
  lead: { name: 'lead', color: '#00008b' },
  magnesium: { name: 'magnesium', color: '#32cd32' },
  molybdenum: { name: 'molybdenum', color: '#8fbc8f' },
  phosphorus: { name: 'phosphorus', title: 'Phosphorous', color: '#b03060' },
  potassium: { name: 'potassium', color: '#ff4500' },
  silicon: { name: 'silicon', color: '#ffa500' },
  sodium: { name: 'sodium', color: '#8a2be2' },
  zinc: { name: 'zinc', color: '#00ffff' },
  nitrite: { name: 'nitrite', color: '#00bfff' },
  nitrate: { name: 'nitrate', color: '#0000ff' },
  phosphate: { name: 'phosphate', color: '#ff7f50' },
  sulfate: { name: 'sulfate', color: '#ff00ff' },
  oxalate: { name: 'oxalate', color: '#1e90ff' },
  acetate: { name: 'acetate', color: '#ffff54' },
  formate: { name: 'formate', color: '#add8e6' },
  glycolate: { name: 'glycolate', color: '#ff1493' },
  fluoride: { name: 'fluoride', color: '#ee82ee' },
  chloride: { name: 'chloride', color: '#c7cf51' }
};

export default {
  graphProps: Object.values(graphProps),
  legendGroups: [
    [
      graphProps.aluminum.name,
      graphProps.boron.name,
      graphProps.calcium.name,
      graphProps.copper.name,
      graphProps.iron.name,
      graphProps.lead.name,
      graphProps.magnesium.name,
      graphProps.molybdenum.name,
      graphProps.phosphorus.name,
      graphProps.potassium.name,
      graphProps.silicon.name,
      graphProps.sodium.name,
      graphProps.zinc.name
    ],
    [
      graphProps.nitrite.name,
      graphProps.nitrate.name,
      graphProps.phosphate.name,
      graphProps.sulfate.name,
      graphProps.oxalate.name,
      graphProps.acetate.name,
      graphProps.formate.name,
      graphProps.glycolate.name,
      graphProps.fluoride.name,
      graphProps.chloride.name
    ]
  ],
  legendPresets: [
    {
      name: 'None',
      options: []
    },
    {
      name: 'All',
      options: Object.values(graphProps).map(({ name }) => name)
    }
  ],
  graphPercentProperties: [
    {
      property: 'water',
      unitOfMeasure: 'waterUnitOfMeasureName'
    }
  ]
};
